import React, { useEffect, useState } from 'react'
import { addEmergencyContactBySite, getCategoryIdlist, updateEmergencyContactBySite } from '../../../services/configurationServices'
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import { emailRegex, nameRegex, numberRegex } from '../EntityConfigUtils/entityConfigUtils';
import { useZone } from '../../../CustomHooks/useZone';


const EmergencyContactAdditionForm = ({ setShowAddSite, showAddSite, selectedRow, handleApplyFilters, fetchFilters, selectedZone, selectedCustomer }) => {
    const [mainCategoryIdList, setMainCatagoryIdList] = useState([]);
    const [contactLevelOptions, setContactLevelOptions] = useState([]);
    const [Category, setCategory] = useState("0");
    const [contactLevel, setContactLevel] = useState("0");
    const [name, setName] = useState("");
    const [contact, setContact] = useState("");
    const [email, setEmail] = useState("");
    //const [zone, setZone] = useState("0");

    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [contactError, setContactError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [contactLevelError, setContactLevelError] = useState("");
    const [zoneError, setZoneError] = useState("");

    const { zoneList, setZoneList, getZoneList } = useZone();

    // useEffect(() => {
    //     if(selectedZone && selectedZone != null){
    //         setZone(selectedZone.value)   
    //     }
    // }, [selectedZone, zoneList])

    useEffect(() => {
        if(selectedRow != null){
            setName(selectedRow?.ContactName);
            setContact(selectedRow?.Phone);
            setEmail(selectedRow?.EmailID);
            setCategory(selectedRow?.CategoryID);
            setContactLevel(selectedRow?.ContactLevel)
            //setZone(selectedRow?.SiteID)
        }
    }, [selectedRow])

    useEffect(() => {
        getCategoryId();
    }, []);

    const getCategoryId = () => {
        try {
            let obj = {
                "type": "ContactCategory_Master",
                "parameters": {
                    "UserId": localStorage.getItem('UserID')
                }
            }
            getCategoryIdlist(obj).then((resp) => {
                if (resp && resp.Status === "success") {
                    let arr = resp.Data || [];
                    setMainCatagoryIdList(arr);
                } else {
                    setMainCatagoryIdList([]);
                }
            })
        } catch (error) {
            console.error(error)
            setMainCatagoryIdList([]);
        }
    }

    useEffect(() => {
        if (Category && Category !== "0") {
            const selectedCategory = mainCategoryIdList.find(
                (cat) => cat.CategoryID === parseInt(Category)
            );
            if (selectedCategory && selectedCategory.LevelLimit) {
                const levels = [];
                for (let i = 1; i <= selectedCategory.LevelLimit; i++) {
                    levels.push(i);
                }
                setContactLevelOptions(levels);
                if(selectedRow != null){
                    setContactLevel(selectedRow?.ContactLevel)
                }else{
                    setContactLevel(levels[0]?.toString() || "0");
                }
                setContactLevelError('')
            } else {
                setContactLevelOptions([]);
                setContactLevel("0");
                setContactLevelError('')
            }
        } else {
            setContactLevelOptions([]);
            setContactLevel("0");
        }
    }, [Category, mainCategoryIdList]);

    const getFormValues = () => {
        // You can collect and validate form values here
        return {
            name,
            email,
            contact,
            Category,
            contactLevel
        };
    }

    const handleSave = (e) => {
        e.preventDefault();
        const formData = getFormValues();
    }

//     const validateForm = () => {
//       if (contact.length !== 10) {
//           showErrorToast("Please enter a valid 10-digit mobile number.");
//       }
//       const contactExists = masterData && masterData.some(record => record.Phone == contact && record.EmergencyContactID != item.EmergencyContactID);
//       if (contactExists) {
//         showErrorToast("This contact number already exists.");
//       }

//       if (Category == "" || Category == "0") {
//           showErrorToast("Please select a category before adding the record.");
//       }
//       // console.log("Category.contactLevel", contactLevel)

//       if (contactLevel == "" || contactLevel == "0") {
//         showErrorToast("Please select a ContactLevel before adding the record.");
//     }
//   };

    const addEmergencyContact = () => {
        // if (!validateForm()) return;
        let isValid = true;

        if (name == "") {
            setNameError("Please enter a name.");
            isValid = false
        }

        if (email == "") {
            setEmailError("Please enter an email address.");
            isValid = false
        }
        if (contact.length !== 10) {
            setContactError("Please enter a valid 10-digit mobile number.");
            isValid = false
        }
        // const contactExists = masterData && masterData.some(record => record.Phone == contact && record.EmergencyContactID != item.EmergencyContactID);
        // if (contactExists) {
        //     setContactError("This contact number already exists.");
        // }
        if (Category == "" || Category == "0" || Category == undefined) {
            setCategoryError("Please select a category before adding the record.");
            isValid = false
        }
        // console.log("Category.contactLevel", contactLevel)

        if (contactLevel == "" || contactLevel == "0" || contactLevel == undefined) {
            setContactLevelError("Please select a contact level before adding the record.");
            isValid = false
        }

        // if (zone == "" || zone == "0") {
        //     setZoneError("Please select a zone before adding the record.");
        //     isValid = false
        // }

        if (!isValid) {
            return
        }
        if (!selectedRow) {
            let addEmergencyContactObj = {
                //"SiteID": (zone).toString(),
                "ClientId": selectedCustomer?.value,
                "ContactName": (name).toString().trim(),
                "Phone": (contact).toString(),
                "SMS": "",
                "Email": "",
                "WhatsApp": "",
                "CreatedOn": "",
                "CreatedBy": "",
                "ModifiedOn": "",
                "ModifiedBy": "",
                "EmailID": (email) ? (email).toString().trim() : "",
                "IsCall": "",
                "InApp": "",
                "SubscriptionArn": "",
                "UserID": "",
                "ContactLevel": (contactLevel).toString(),
                "Designation": "",
                "IsERT": "",
                "IsCustomerSPOC": "",
                "OrganizationMasterID": JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
                "CategoryID": (Category).toString(),
                "CategoryName": "",
                "UpdatedateTime": ""
            }
            addEmergencyContactBySite(addEmergencyContactObj).then((resp) => {
                if (resp.Status == "success") {
                    SuccessToast('Emergency Contact Added Successfully');
                    clearForm()
                    handleApplyFilters();
                }
                else {
                    ErrorToast(resp.Message)
                    console.error(resp.Message)
                }
            })

        } else {
            let updateAlertPrePostDetailsObj = {
                "EmergencyContactID" : (selectedRow?.EmergencyContactID).toString(),
                //"SiteID": (zone).toString(),
                "ClientId": selectedCustomer?.value,
                "ContactName": (name).toString().trim(),
                "Phone": (contact),
                "SMS": "",
                "Email": "",
                "WhatsApp": "",
                "CreatedOn": "",
                "CreatedBy": "",
                "ModifiedOn": "",
                "ModifiedBy": "",
                "EmailID": (email) ? (email).toString().trim() : "",
                "IsCall": "",
                "InApp": "",
                "SubscriptionArn": "",
                "UserID": "",
                "ContactLevel": (contactLevel).toString(),
                "Designation": "",
                "IsERT": "",
                "IsCustomerSPOC": "",
                "OrganizationMasterID": JSON.parse(localStorage.getItem('user')).OrganizationMasterID.toString(),
                "CategoryID": (Category).toString(),
                "CategoryName": "",
                "UpdatedateTime": ""
            }
            updateEmergencyContactBySite(updateAlertPrePostDetailsObj).then((resp) => {
                if (resp.Status == "success") {
                    SuccessToast('Emergency Contact Updated Successfully');
                    handleApplyFilters();
                }
                else {
                    ErrorToast(resp.Message)
                }
            }).catch((error) => {
                console.log("Error", error)
            })
        }
    }

    const clearForm = () => {
        setName("")
        setEmail("")
        setContact("")
        setCategory("0")
        setContactLevel("0")
        //setZone("0")
        setNameError("")
        setEmailError("")
        setContactError("")
        setCategoryError("")
        setContactLevelError("")
        setZoneError("")
    }

    return (
        <div className="SiteMainContainer SiteTableMainDiv p-2">
            <h5>{selectedRow == null ? 'Add' : 'Edit'} emergency contact</h5>
            <div className='SiteFormAdditionForm'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Contact name*</label>
                                <input
                                    className="inputType"
                                    placeholder="Enter Name*"
                                    value={name}
                                    onChange={e => {
                                        setName(e.target.value)
                                        setNameError("")
                                    }}
                                    onKeyPress={nameRegex}
                                    required
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{nameError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Email ID*</label>
                                <input
                                    className="inputType"
                                    placeholder="Enter Email ID*"
                                    value={email}
                                    onChange={e => {
                                        setEmail(e.target.value)
                                        setEmailError("")}}
                                    required
                                    onKeyPress={emailRegex}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{emailError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Mobile No*</label>
                                <input
                                    className="inputType"
                                    placeholder="Enter Mobile No."
                                    value={contact}
                                    onChange={e => {setContact(e.target.value)
                                        setContactError("")}}
                                    required
                                    onKeyPress={numberRegex}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {contactError}</span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Category*</label>
                                <select
                                    className="inputType ArrowSelectClass"
                                    value={Category}
                                    onChange={e => {setCategory(e.target.value)
                                        setCategoryError("")}}
                                    required
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Category*</option>
                                    {mainCategoryIdList &&
                                        mainCategoryIdList.map((item) => (
                                            <option value={item.CategoryID} key={item.CategoryID}>
                                                {item.CategoryName}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span>{categoryError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Level*</label>
                                <select
                                    className="inputType ArrowSelectClass"
                                    value={contactLevel}
                                    onChange={e => {setContactLevel(e.target.value)
                                        setContactLevelError("")}}
                                    required
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Level*</option>
                                    {contactLevelOptions.map((level) => (
                                        <option value={level} key={level}>
                                            {level}
                                        </option>
                                    ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span>{contactLevelError} </span></p>
                            </div>
                        </div>
                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Zone</label>
                                <select
                                    className="inputType ArrowSelectClass"
                                    value={zone}
                                    onChange={e => {setZone(e.target.value)
                                        setZoneError("")}}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Zone*</option>
                                    {
                                        zoneList.map((item) => (
                                            <option value={item.SiteID} key={item.SiteID} >{item.SiteName}</option>
                                        ))
                                    }
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span>{zoneError} </span></p>
                            </div>
                        </div> */}
                    </div>
                </form>
            </div>
             <div style={{ textAlign: "center" }}>
                <button className="DataAccessEdit" style={{ width: "100px" }} type="submit" onClick={addEmergencyContact}>
                    <span className="ViewUpdate">Save</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px" }} type="button" onClick={() => setShowAddSite(false)}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </div>
    )
}

export default EmergencyContactAdditionForm